<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">WPCal.io - {{ T__("Bookings") }}</h1>
        <AdminHeaderRight />
      </div>
      <div class="se-cont">
        <ul class="se-nav">
          <li
            :class="{ active: tabs_view.upcoming }"
            @click="switch_tabs('upcoming')"
          >
            {{ T__("UPCOMING") }}
          </li>
          <li :class="{ active: tabs_view.past }" @click="switch_tabs('past')">
            {{ T__("PAST") }}
          </li>
          <li
            :class="{ active: tabs_view.custom }"
            @click="switch_tabs('custom')"
          >
            {{ T__("Find a Booking") }}
          </li>
        </ul>
        <div id="booking_list_cont">
          <div v-if="tabs_view.upcoming">
            <ServiceBookingFilters v-model="filter_options" />
            <ServiceBookingList
              :booking_list_type="'upcoming'"
              :booking_details="upcoming_bookings"
              :filter_options="filter_options"
              @remove-booking="remove_booking($event)"
              @load-page="load_page($event)"
            />
          </div>
          <div v-if="tabs_view.past">
            <ServiceBookingFilters v-model="filter_options" />
            <ServiceBookingList
              :booking_list_type="'past'"
              :booking_details="past_bookings"
              :filter_options="filter_options"
              @load-page="load_page($event)"
            />
          </div>
          <div v-if="tabs_view.custom">
            <ServiceBookingFilters
              :filter_options="custom_filter_options"
              mode="custom"
            />
            <ServiceBookingList
              :booking_list_type="'custom'"
              :booking_details="custom_bookings"
              @remove-booking="remove_booking($event)"
              @load-page="load_page($event)"
            />
          </div>
        </div>
      </div>
      <TimeZoneSelector />
    </div>
    <!-- <AdminInfoLine info_slug="ownership_my_bookings" class="mt10" /> -->
  </div>
</template>

<script>
import ServiceBookingList from "@/components/admin/ServiceBookingList.vue";
import ServiceBookingFilters from "@/components/admin/ServiceBookingFilters.vue";
import TimeZoneSelector from "@/components/form_elements/TimeZoneSelector.vue";

import { getUnixTime } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

// import { required } from "vuelidate/lib/validators";

// import { format } from "date-fns";

import { debounce, isEqual as _isEqual } from "lodash-es";

import axios from "axios";

export default {
  components: {
    ServiceBookingList,
    ServiceBookingFilters,
    TimeZoneSelector
  },
  props: {
    redirected_to_admin_end_booking: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      document_title: "Bookings",
      //view_base_timing: format(new Date(), "t"),
      upcoming_bookings: {
        page: -1,
        eol: false,
        total_items: 0,
        items_per_page: 20, //dummy data for default, actual loads from backend
        bookings: []
      },
      past_bookings: {
        page: -1,
        eol: false,
        total_items: 0,
        items_per_page: 20, //dummy data for default, actual loads from backend
        bookings: []
      },
      custom_bookings: {
        page: -1,
        eol: false,
        total_items: 0,
        items_per_page: 20, //dummy data for default, actual loads from backend
        bookings: []
      },
      tabs_view: {
        upcoming: true,
        past: false,
        custom: false
      },
      default_tab_options: {
        page: -1,
        eol: false,
        bookings: []
      },
      // custom_filters: {
      //   text: ""
      // },
      filter_options: {
        admin_user_id: this.$store.getters.get_current_admin_details.id,
        booking_status: "1",
        service_id: "0"
      },
      custom_filter_options: {
        admin_user_id: this.$store.getters.get_current_admin_details.id,
        booking_status: "1",
        service_id: "0",
        when: "upcoming",
        date_range: {
          from_date_ts: "",
          to_date_ts: "",
          start: new Date(), //will be set to from_date on form submit
          end: new Date() //will be set to to_date on form submit
        },
        search_text: ""
      },
      custom_filter_options_initial_loaded_value: {},
      no_more_customer_filter_set_filters_to_all: false,
      last_custom_filter_options_search_text: "",
      redirected_to_admin_end_booking_notice_shown: false
    };
  },
  // validations: {
  //   custom_filters: {
  //     text: { required }//validation not required, commented
  //   }
  // },
  computed: {
    current_view() {
      if (this.tabs_view.upcoming == true) {
        return "upcoming";
      } else if (this.tabs_view.past == true) {
        return "past";
      } else if (this.tabs_view.custom == true) {
        return "custom";
      }
      return "";
    }
  },
  methods: {
    switch_tabs(list_type) {
      if (list_type === "upcoming") {
        this.tabs_view.upcoming = false;
        this.tabs_view.past = false;
        this.tabs_view.custom = false;
        this.$nextTick(() => {
          //for re-rendering
          this.tabs_view.upcoming = true;
        });

        this.upcoming_bookings = this.clone_deep(this.default_tab_options);
        this.get_bookings("upcoming");
        // if (
        //   this.upcoming_bookings.page == -1 &&
        //   this.upcoming_bookings.eol == false
        // ) {
        //   this.get_bookings("upcoming");
        // }
      } else if (list_type === "past") {
        this.tabs_view.upcoming = false;
        this.tabs_view.past = false;
        this.tabs_view.custom = false;

        this.$nextTick(() => {
          //for re-rendering
          this.tabs_view.past = true;
        });

        this.past_bookings = this.clone_deep(this.default_tab_options);
        this.get_bookings("past");
        // if (this.past_bookings.page == -1 && this.past_bookings.eol == false) {
        //   this.get_bookings("past");
        // }
      } else if (list_type === "custom") {
        this.tabs_view.upcoming = false;
        this.tabs_view.past = false;
        this.tabs_view.custom = false;

        this.$nextTick(() => {
          //for re-rendering
          this.tabs_view.custom = true;
        });

        this.custom_bookings = this.clone_deep(this.default_tab_options);
        this.get_bookings("custom");
        // if (
        //   this.custom_bookings.page == -1 &&
        //   this.custom_bookings.eol == false
        // ) {
        //   this.get_bookings("custom");
        // }
      }
    },
    // following commented because load_more() concept no longer used
    // load_more(list_type) {
    //   if (
    //     list_type !== "upcoming" &&
    //     list_type !== "past" &&
    //     list_type !== "custom"
    //   ) {
    //     return;
    //   }
    //   if (!this[list_type + "_bookings"].eol) {
    //     let requested_page = this[list_type + "_bookings"].page + 1;
    //     this.get_bookings(list_type, requested_page);
    //   }
    // },
    load_page: debounce(function(details) {
      this.get_bookings(details.list_type, details.page);
    }, 10),
    load_bookings_page() {
      this.get_bookings(this.current_view);
    },
    get_bookings(list_type, requested_page = 1) {
      if (
        list_type !== "upcoming" &&
        list_type !== "past" &&
        list_type !== "custom"
      ) {
        return false;
      }
      let wpcal_request = {};
      let action = "get_managed_bookings_for_current_admin";
      let data_name = list_type + "_bookings";

      let options = {
        list_type: list_type,
        //view_base_timing: this.view_base_timing,
        filters: this.filter_options,
        page: requested_page
      };
      if (list_type === "custom") {
        options.filters = this.clone_deep(this.custom_filter_options);
        //getUnixTime(zonedTimeToUtc()) used to convert the date in browser timezone to the view_in tz selector at the bottom of the page and then convert to unix for easy use in backend
        options.filters.date_range.from_date_ts = getUnixTime(
          zonedTimeToUtc(options.filters.date_range.start, this.tz)
        );
        options.filters.date_range.to_date_ts = getUnixTime(
          zonedTimeToUtc(options.filters.date_range.end, this.tz)
        );
        delete options.filters.date_range.start;
        delete options.filters.date_range.end;
      }
      wpcal_request[action] = {
        options: options
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (
            response.data &&
            response.data[action].hasOwnProperty("bookings_data")
          ) {
            // following commented because load_more() concept no longer used
            // if (
            //   // list_type == "custom" &&
            //   response.data[action].bookings_data.page == 1
            // ) {
            //   this[data_name].bookings = [];
            // }
            // this[data_name].bookings = this[data_name].bookings.concat(
            //   response.data[action].bookings_data.bookings
            // );

            this[data_name].bookings =
              response.data[action].bookings_data.bookings;

            this[data_name].page = parseInt(
              response.data[action].bookings_data.page
            );
            this[data_name].total_items = parseInt(
              response.data[action].bookings_data.total_items
            );
            this[data_name].items_per_page = parseInt(
              response.data[action].bookings_data.items_per_page
            );
            this[data_name].eol = response.data[action].bookings_data.eol;
            this.$nextTick(() => {
              this.scroll_to("#booking_list_cont", 0, true);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // search_bookings() {
    //   //reset custom_bookings
    //   this.custom_bookings.page = -1;
    //   this.custom_bookings.eol = false;
    //   this.custom_bookings.bookings = [];

    //   // //validate
    //   // this.$v.custom_filters.$touch(); //trigger validation

    //   // if (this.$v.custom_filters.$anyError) {
    //   //   this.scroll_to_first_validation_error();
    //   //   return;
    //   // }

    //   // if (!this.custom_filters.text.trim()) {
    //   //   //if no text return
    //   //   return;
    //   // }

    //   //all ok - go head and search
    //   this.get_bookings("custom");
    // },
    // set_view_base_timing() {
    //   this.view_base_timing = format(new Date(), "t");
    // },
    remove_booking(booking_remove_details) {
      if (
        booking_remove_details.booking_list_type !== "upcoming" &&
        booking_remove_details.booking_list_type !== "custom"
      ) {
        return false;
      }
      let bookings_var_name =
        booking_remove_details.booking_list_type + "_bookings";
      let result_index;
      if (booking_remove_details.hasOwnProperty("booking_id")) {
        let booking_id = booking_remove_details.booking_id;
        result_index = this[bookings_var_name].bookings.findIndex(_booking => {
          return _booking.id == booking_id;
        });
      } else if (booking_remove_details.hasOwnProperty("booking_unique_link")) {
        let booking_unique_link = booking_remove_details.booking_unique_link;
        result_index = this[bookings_var_name].bookings.findIndex(_booking => {
          return _booking.unique_link == booking_unique_link;
        });
      }

      if (result_index !== -1) {
        this[bookings_var_name].bookings.splice(result_index, 1);
      }
    },
    debounced_search: debounce(function() {
      this.load_bookings_page();
    }, 200),
    one_time_on_custom_filter_search_text_used_set_other_filters_to_all() {
      //assuming this will call on search_text change
      if (this.no_more_customer_filter_set_filters_to_all) {
        return;
      }
      let current_custom_filters = this.clone_deep(this.custom_filter_options);
      let custom_filters_initial_loaded_value = this.clone_deep(
        this.custom_filter_options_initial_loaded_value
      );
      delete current_custom_filters.search_text;
      delete current_custom_filters.date_range; //better to avoid date_range, if when filter changed to 'date_range' that is enough

      delete custom_filters_initial_loaded_value.search_text;
      delete custom_filters_initial_loaded_value.date_range;

      let is_equal = _isEqual(
        current_custom_filters,
        custom_filters_initial_loaded_value
      );

      if (!is_equal) {
        this.no_more_customer_filter_set_filters_to_all = true;
        return;
      }

      //set other filters to all
      let other_filters_set_to_all = {
        admin_user_id: "0",
        booking_status: "0",
        service_id: "0",
        when: "0"
      };
      this.custom_filter_options = Object.assign(
        this.custom_filter_options,
        other_filters_set_to_all
      );
      this.no_more_customer_filter_set_filters_to_all = true;
    },
    may_booking_custom_by_id_process() {
      if (this.$route.name == "booking_custom_by_id") {
        this.may_show_notice_for_redirected();
        if (typeof this.$route.params.booking_id === "string") {
          let booking_id = this.$route.params.booking_id.trim();
          if (booking_id) {
            this.custom_filter_options.search_text = booking_id;
            this.custom_filter_options.admin_user_id = "0";
            this.custom_filter_options.booking_status = "0";
            this.custom_filter_options.service_id = "0";
            this.custom_filter_options.when = "0";
            this.switch_tabs("custom");

            this.no_more_customer_filter_set_filters_to_all = true;
            //this.search_bookings();
            this.$router.push({ name: "booking_list" }); //just redirect - required content will be loaded - this done if again user goes on to click a link with 'booking_custom_by_id' it is not working - so this is workaround fix
            return true;
          }
        }
        this.$router.push({ name: "booking_list" });
      }
    },
    may_show_notice_for_redirected() {
      if (
        this.redirected_to_admin_end_booking &&
        !this.redirected_to_admin_end_booking_notice_shown
      ) {
        this.redirected_to_admin_end_booking_notice_shown = true;
        this.$toast.success(
          "WPCal admins can view manage the bookings only from admin end. Front end only for the invitees.",
          "You have been redirected to admin end",
          {}
        );
      }
    }
  },
  mounted() {
    this.$store.dispatch("load_managed_active_admins_details");

    let filter_date_range = this.custom_filter_options.date_range;
    filter_date_range.start.setDate(filter_date_range.start.getDate() - 30); //set start date last 30 days
    filter_date_range.start.setHours(0, 0, 0, 0);
    filter_date_range.end.setHours(0, 0, 0, 0);

    this.custom_filter_options_initial_loaded_value = this.clone_deep(
      this.custom_filter_options
    );

    if (this.may_booking_custom_by_id_process()) {
      return;
    }

    //this.set_view_base_timing();
    this.load_bookings_page();
  },
  watch: {
    filter_options: {
      handler(new_val) {
        this.load_bookings_page();
        // Follwoing commented as on clicking each tab it gonna fetch bookings
        // let default_tab_options = {
        //   page: -1,
        //   eol: false,
        //   bookings: []
        // };
        // //upcoming & past share same filter and its values. While change in filter reset the other tab options
        // let reset_tab = this.current_view == "upcoming" ? "past" : "upcoming";
        // this[reset_tab + "_bookings"] = Object.assign(
        //   this[reset_tab + "_bookings"],
        //   default_tab_options
        // );
      },
      deep: true
    },
    // "custom_filter_options.search_text": debounce(function(new_val, old_val) {
    //   this.load_bookings_page();
    // }, 200),
    custom_filter_options: {
      handler(new_val, old_val) {
        if (
          new_val.search_text != this.last_custom_filter_options_search_text
        ) {
          //object property(child) new_val and old_val is coming same
          this.one_time_on_custom_filter_search_text_used_set_other_filters_to_all();
          this.debounced_search();
        } else {
          //this.load_bookings_page();
          this.debounced_search(); //there will be delay of 200ms thats ok it is needed when one_time_on_custom_filter_search_text_used_set_other_filters_to_all() is called - again comes here
        }
        this.last_custom_filter_options_search_text = new_val.search_text;
      },
      deep: true
    },
    tz() {
      if (
        this.current_view == "custom" &&
        this.custom_filter_options.when == "date_range"
      ) {
        this.load_bookings_page();
      }
    },
    "$route.name": function(new_route_name, old_route_name) {
      if (new_route_name == "booking_custom_by_id") {
        this.may_booking_custom_by_id_process();
      }
    }
  }
};
</script>

<style src="@/assets/css/admin_service_bookings.css"></style>
